import L from "leaflet";


const MarkerIcon = (
  type,
  color = [],
  isSelected = false,
  cluster,
  isCluster = false,
  selectedInstitution,
  innerIcon = ""
) => {
  //---------------allow to set an active state (change cluster Icon color) to the cluster via isInCluster
  if (isCluster) {
    // let isInCluster = false;
    // const clusterChildMarkers = cluster.getAllChildMarkers();
    // if (selectedInstitution) {
    //   for (const clusterChildMarker of clusterChildMarkers) {
    //     if (clusterChildMarker.options.calc.id === selectedInstitution.id) {
    //       isInCluster = true;
    //       //cluster.spiderfy();
    //     }
    //   }
    // }

    return L.divIcon({
      // Cluster icon
      html: `
      <svg class="cluster-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
              <circle class="colored-circle" cx="20" cy="20" r="18"/>
              <circle  cx="20" cy="20" r="15" fill="#fff"/>
              </svg>
              <div class="cdg-cluster-icon__child-count">${cluster.getChildCount()}</div>
            `,
      iconSize: L.point(40, 40, true),
      className: "custom-marker-cluster",
    });
  } else {
    // One color marker
    const icon1 = L.divIcon({
      className: `my-custom-pin ${isSelected ? "active" : ""}`,
      iconSize: [40, 40], // size of the icon
      iconAnchor: [20, 40],
      labelAnchor: [-6, 0],
      popupAnchor: [0, -40],
      html: `
      <div class="markerIcon">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 30.3 39.3" enable-background="new 0 0 30.3 39.3" xml:space="preserve">
   <g id="Composant_39_58_00000147196838336489765460000015177202678015056013_">
     <g>
       <g id="Groupe_533_00000133489344108334918850000015642197409747194043_">
         <path id="Tracé_429_00000046337187598095373690000016485342927176903817_" fill="${color[0]}" d="M13.2,0.5
           C5.1,1.6-0.7,9.2,0.5,17.3c0,0.1,0,0.3,0.1,0.4C1.1,21.1,3,23.8,8,30.9c1.1,1.6,2.4,3.5,3.9,5.6c0.5,0.8,1.1,1.4,1.8,2
           c0.4,0.2,0.9,0.3,1.4,0.3c0.4,0,0.8-0.1,1.1-0.2c0.5-0.2,1-0.6,1.3-1.1c1.8-2.6,3.3-4.8,4.6-6.7c6.2-8.8,7.6-10.9,7.6-15.7
           C29.8,7,23.2,0.4,15,0.4C14.4,0.4,13.8,0.4,13.2,0.5 M15.1,20.1L14.2,20c-2.7-0.5-4.5-3.1-4-5.8c0.4-2.3,2.5-4,4.9-4h0
           c2.7,0,5,2.2,5,4.9C20,17.9,17.8,20.1,15.1,20.1"/>
       </g>
     </g>
   </g>
   </svg>
      <div class="innerIcon">${innerIcon}</div>
      </div>
      `,
    });
    return icon1;
  }
};

export default MarkerIcon;
